import t from 'tcomb';

const Country = t.enums.of(['AT', 'AU', 'BE', 'BR', 'CA', 'CH', 'CZ', 'DE', 'DK', 'ES', 'FR', 'GB', 'IE', 'IT', 'LU', 'MC', 'NL', 'NO', 'PL', 'PT', 'SE', 'TR', 'US', 'ZA']);

module.exports = Country;


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Country.js
 **/